// Token-based `styles` for react-select, so searchable selects match ds-input.
// Same look as dsSelectStyles in ../profile.tsx, plus a disabled state.
// Promote into src/ui alongside Select when react-select gets a wrapper there.
import type { GroupBase, StylesConfig } from 'react-select';

export function dsReactSelectStyles<Option = unknown, IsMulti extends boolean = false>(): StylesConfig<
  Option,
  IsMulti,
  GroupBase<Option>
> {
  return {
    control: (base, state) => ({
      ...base,
      minHeight: 'var(--ds-control-md)',
      borderRadius: 'var(--ds-radius-sm)',
      borderColor: state.isFocused ? 'var(--ds-primary)' : 'var(--ds-border-strong)',
      boxShadow: state.isFocused ? 'var(--ds-focus-ring)' : 'none',
      backgroundColor: state.isDisabled ? 'var(--ds-disabled-bg)' : 'var(--ds-surface)',
      cursor: state.isDisabled ? 'not-allowed' : base.cursor,
      fontSize: '14px',
    }),
    singleValue: (base, state) => ({
      ...base,
      color: state.isDisabled ? 'var(--ds-disabled-text)' : 'var(--ds-text)',
    }),
    input: (base) => ({ ...base, color: 'var(--ds-text)' }),
    placeholder: (base) => ({ ...base, color: 'var(--ds-text-subtle)' }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
      borderRadius: 'var(--ds-radius-sm)',
      boxShadow: 'var(--ds-shadow-lift)',
      backgroundColor: 'var(--ds-surface)',
      color: 'var(--ds-text)',
    }),
    option: (base, state) => ({
      ...base,
      fontSize: '14px',
      backgroundColor: state.isDisabled
        ? 'var(--ds-surface-muted)'
        : state.isSelected
          ? 'var(--ds-primary)'
          : state.isFocused
            ? 'var(--ds-primary-soft)'
            : 'transparent',
      color: state.isDisabled
        ? 'var(--ds-disabled-text)'
        : state.isSelected
          ? 'var(--ds-text-on-dark)'
          : 'var(--ds-text)',
      cursor: state.isDisabled ? 'not-allowed' : 'pointer',
      opacity: state.isDisabled ? 0.72 : 1,
      fontStyle: state.isDisabled ? 'italic' : 'normal',
    }),
  };
}
